export const aiIncidentsQueryKeys = {
  all: ['ai-incidents'] as const,
  list: ({ eventId, page, pageSize }: { eventId?: number; page: number; pageSize: number }) =>
    [...aiIncidentsQueryKeys.all, 'list', eventId, page, pageSize] as const,
};
